import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "./FeatureAppointmentSchedulingRequirements.css";

function FeatureAppointmentSchedulingRequirements({ user }) {
  // Add a new state for address
  const [apptRequiresAddress, setApptRequiresAddress] = useState(user.appt_requires_address);
  const [apptRequiresFullname, setApptRequiresFullname] = useState(true);
  const [apptRequiresEmail, setApptRequiresEmail] = useState(user.appt_requires_email);
  const [apptRequiresPhoneNumber, setApptRequiresPhoneNumber] = useState(user.appt_requires_phone_number);
  const [apptRequiresMessage, setApptRequiresMessage] = useState(null);

  useEffect(() => {
    // Initialize state with user settings
    setApptRequiresAddress(user.appt_requires_address);
    setApptRequiresFullname(user.appt_requires_fullname); 
    setApptRequiresEmail(user.appt_requires_email); 
    setApptRequiresPhoneNumber(user.appt_requires_phone_number); 
    setApptRequiresMessage(user.appt_requires_message); 
  }, [user]);

  const handleSave = async (clickedArg) => {
    const jwt_token = localStorage.getItem('jwt_authorization');
    let payload = { jwt_token };

    // Update state and payload based on the clicked argument
    if (clickedArg === "apptRequiresAddress") {
      payload.appt_requires_address = !apptRequiresAddress;
      setApptRequiresAddress(!apptRequiresAddress);
    }
    
    if (clickedArg === "apptRequiresFullname") {
      payload.appt_requires_fullname = !apptRequiresFullname;
      setApptRequiresFullname(!apptRequiresFullname);
    }

    if (clickedArg === "apptRequiresEmail") {
      payload.appt_requires_email = !apptRequiresEmail;
      setApptRequiresEmail(!apptRequiresEmail);
    }

    if (clickedArg === "apptRequiresPhoneNumber") {
      payload.appt_requires_phone_number = !apptRequiresPhoneNumber;
      setApptRequiresPhoneNumber(!apptRequiresPhoneNumber);
    }

    if (clickedArg === "apptRequiresMessage") {
      payload.appt_requires_message = !apptRequiresMessage;
      setApptRequiresMessage(!apptRequiresMessage);
    }

    try {
      const response = await axios.put(`${process.env.REACT_APP_BACKEND_HOST}/user`, payload);

    } catch (error) {
      console.error('Failed to update:', error);
    }

  };


  return (
    <div className='scheduling-requirements-container'>
      <span className='general-info-label'>Required contact types to collect</span>

      <div className='scheduling-requirements-wrapper'>
        <div className='requirement-item' style={{ display:"none"}}>
        <label htmlFor="fullName">Full Name</label>
          <input className='checkbox' type="checkbox" id="apptRequiresFullname" name="apptRequiresFullname" checked={apptRequiresFullname} onChange={() => {handleSave("apptRequiresFullname")}} />
          
        </div>
        <div className='requirement-item'>
        <label htmlFor="email">Email</label>
          <input className='checkbox'  type="checkbox" id="apptRequiresEmail" name="apptRequiresEmail" checked={apptRequiresEmail} onChange={() => {handleSave("apptRequiresEmail")}} />

        </div>
        <div className='requirement-item'>
        <label htmlFor="phone">Phone</label>
          <input className='checkbox' type="checkbox" id="apptRequiresPhoneNumber" name="apptRequiresPhoneNumber" checked={apptRequiresPhoneNumber} onChange={() => {handleSave("apptRequiresPhoneNumber")}} />

        </div>
        {/* <div className='requirement-item'>
        <label htmlFor="message">Message</label>
          <input className='checkbox' type="checkbox" id="apptRequiresMessage" name="apptRequiresMessage" checked={apptRequiresMessage} onChange={() => {handleSave("apptRequiresMessage")}} />
          
        </div> */}

        <div className='requirement-item'>
        <label htmlFor="address">Address</label>
        <input 
          className='checkbox' 
          type="checkbox" 
          id="apptRequiresAddress" 
          name="apptRequiresAddress" 
          checked={apptRequiresAddress} 
          onChange={() => { handleSave("apptRequiresAddress") }}
        />
      </div>

      </div>

    </div>

  );
}

export default FeatureAppointmentSchedulingRequirements
